import axios from 'axios'
import 'babel-polyfill'
// var qs = require('qs')

// 得到 Authorization
function getAuthorization () {
  return localStorage.getItem('authorization')
}

// 设置cookie
// function setCookie (name, value, domain, path, expires) {
//   exdate.setDate(exdate.getDate()+expiredays)
//   document.cookie = name + '=' + escape(value) +
//   ((expiredays==null) ? "" : ";expires="+exdate.toGMTString())
// }
axios.defaults.withCredentials = true
// axios.defaults.credentials = true
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.put['Content-Type'] = 'application/json'
// 配置 API 接口参数
axios.defaults.baseURL = process.env.API_ROOT

axios.interceptors.request.use(function (config) {
  /**
   * 如果是请求以下接口，则不需要带 Authorization
   * 1./is_login
   * 2./login_wechat_qrcode_wx
   * 3./login_wechat_qrcode_pc
   */
  // if ((config && config.url.match(/is_login$/)) ||
  //     (config && config.url.match(/login_wechat_qrcode_wx$/)) ||
  //     (config && config.url.match(/login_wechat_qrcode_pc$/))) {

  // } else {
  if (getAuthorization()) {
    config.headers.common['Authorization'] = getAuthorization()
  }
  // }
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use((response) => {
  // console.log(response)
  // console.log(response.headers)
  let data = response.data
  switch (parseInt(data.code)) {
    case 1:
    case -10003:
    case -10004:
    case -10005:
    case -70001:
    case -20001:
    case -70004:
    case 20032: // 账户异常
    case -2003:
    case -3003:
    case 20001: // 用户未登陆
    case 10011: // 验证码错误
    case 10012: // 验证码已过期
    case 10013: // 手机验证码发送失败
    case 10014: // 手机验证码操作频繁
    case 10015: // 手机验证码未知错误
    case 40004: // 数据已经存在
    case 50001: // 系统异常
      return data
    case 10001: // 参数格式错误
      // location.href = '/notfound'
      break
    default:
      return Promise.reject(data.message)
  }
}, (error) => {
  // 无响应，无网络
  if (!error.response) {
    return Promise.reject(new Error('网络连接异常'))
  } else {
    return Promise.reject(new Error('抱歉，服务器开了点小差~'))
  }
})

/**
 * 公共的接口
 */
// 大学名称联想 http://yapi.acagrid.com/project/13/interface/api/583
export const schoolNameSuggestion = params => axios.get('school_name_suggestion', {params})

/**
 * 学术主页宣传页 相关的API接口
 */
// 查询当前用户的信息 http://yapi.acagrid.com/project/13/interface/api/699
export const isLogin = params => axios.get('is_login', {params})

// 微信端扫码登录 http://yapi.acagrid.com/project/13/interface/api/571
export const getQrcode = params => axios.get('login_wechat_qrcode_pc')

// 微信扫码轮询接口 http://yapi.acagrid.com/project/13/interface/api/653
export const wechatPolling = params => axios.get('login_wechat_qrcode_userinfo', {params})

/**
 * 创建页面 相关的API的接口
 */
// 获取手机验证码 http://yapi.acagrid.com/project/13/interface/api/573
export const getVerifyCode = params => axios.get('/mobile_code', {params})

// 创建主页step1：创建主页 http://yapi.acagrid.com/project/13/interface/api/555
export const creatHomepage = params => axios.post('academic_homepages', params)

/**
 * 检索页面 相关的API的接口
 */
// 创建主页step2：检索成果 http://yapi.acagrid.com/project/13/interface/api/647
export const checkDocs = id => axios.get(`academic_homepages/${id}/check_docs`)

// 创建主页step3：确认导入成果 http://yapi.acagrid.com/project/13/interface/api/597
export const importDocs = (id, params) => axios.post(`academic_homepages/${id}/import_docs`, params)

// 创建示例主页 http://yapi.acagrid.com/project/13/interface/api/1111
export const importEgDocs = (id) => axios.post(`/academic_homepages/${id}/generate_demo_docs`)
/**
 * 学术主页页面 相关的API接口
 */
// 浏览学术主页 http://yapi.acagrid.com/project/13/interface/api/561
export const academicHomepages = id => axios.get(`academic_homepages/${id}`)

// 获取阿里云OSS上传文件签名 http://yapi.acagrid.com/project/13/interface/api/545
export const ossSign = params => axios.get('system/upload_oss_sign', {params})

// 编辑学术主页保存 http://yapi.acagrid.com/project/13/interface/api/567
export const saveAcademicHomepages = (id, params) => axios.put(`academic_homepages/${id}`, params)

// 移动端--保存个人资料-- http://yapi.acagrid.com/project/13/interface/api/561
export const savePersonalData = (id, params) => axios.patch(`academic_homepages/${id}/profile`, params)

// 移动端--浏览个人资料-- http://yapi.acagrid.com/project/13/interface/api/561
export const seePersonalData = id => axios.get(`academic_homepages/${id}/profile`)

// 微信端扫码登录 http://yapi.acagrid.com/project/13/interface/api/571
export const getQrcodeMobile = params => axios.get('login_wechat_qrcode_wx')

// 根据中文名获取8中英文名字 http://yapi.acagrid.com/project/13/interface/api/509
export const getCommonEnnames = params => axios.get('coauthors/get_common_ennames', {params})

// 退出登录 http://yapi.acagrid.com/project/13/interface/api/717
export const logout = params => axios.get('logout')

// 获取微信网页签名 http://yapi.acagrid.com/project/13/interface/api/709
export const getWxSignature = params => axios.get('/system/wechat_share_sign', {params})

// 验证手机并登陆 http://yapi.acagrid.com/project/13/interface/api/995
export const checkMobileLogin = params => axios.post('/check_mobile_login', params)

// 分页获取学术主页访客记录 http://yapi.acagrid.com/project/13/interface/api/991
export const getPageData = (id, params) => axios.get(`academic_homepages/${id}/visit_logs`, {params})

// 点赞学术主页 http://yapi.acagrid.com/project/13/interface/api/989
export const likes = (id) => axios.post(`academic_homepages/${id}/likes`)

// 微信授权获取用户信息 http://yapi.acagrid.com/project/13/interface/api/997
export const getUserInfo = params => axios.get('/wechat_oauth', {params})

// 学术主页扫码登录 http://yapi.acagrid.com/project/13/interface/api/785
export const scholarGetQrcode = params => axios.get('/group_qrcode', {params})

// 学术主页 获取第一页后剩余成果 http://yapi.acagrid.com/project/13/interface/api/1109
export const getMoreDocs = (id, params) => axios.get(`/academic_homepages/${id}/docs`, {params})

// 学术主页保存用户上传自定义封面 http://yapi.acagrid.com/project/13/interface/api/1107
export const getCustomCover = (id, params) => axios.patch(`/academic_homepages/${id}/custom_cover`, params)



// WEBPACK FOOTER //
// ./src/api/index.js